import { InputCCBillPurchaseDeposit } from "@scrile/api-provider/dist/api/CCBillPurchaseProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { Subscription } from "@scrile/api-provider/dist/api/SubscriptionProvider";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import providers from "@/lib/api";
import paymentComponent from "./CCBill.vue";
import { IntegrationModule } from "../types";

const module: IntegrationModule<InputCCBillPurchaseDeposit["billingDetails"]> = {
  paymentComponent,
  purchase: async (data, billingDetails) => {
    const transaction: Transaction = await providers.CCBillPurchaseProvider.purchaseDeposit({
      data: { ...data, billingDetails },
    });
    return {
      status: true,
      subjectPurchased: false,
      transaction,
    };
  },
  subscribe: async (data, billingDetails) => {
    const subscription: Subscription = await providers.CCBillPurchaseProvider.purchaseRecurring({
      data: {
        ...data,
        billingDetails,
      },
    });
    return {
      status: true,
      subjectPurchased: false,
      subscription,
    };
  },
  allowSaveCard: true,
};

export const selector = (system: PaymentSystemPublic | null): boolean => {
  return system?.type === "ccbill" ?? false;
};

export default module;
